/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingFieldViolation } from './BookingFieldViolation';
import {
    BookingFieldViolationFromJSON,
    BookingFieldViolationFromJSONTyped,
    BookingFieldViolationToJSON,
    BookingFieldViolationToJSONTyped,
} from './BookingFieldViolation';

/**
 * Returned with 400 when booking is refused because the shipment is not ready to book
 * @export
 * @interface BookShipmentError
 */
export interface BookShipmentError {
    /**
     * All violations joined into one line
     * @type {string}
     * @memberof BookShipmentError
     */
    errorMessage: string;
    /**
     * 
     * @type {Array<BookingFieldViolation>}
     * @memberof BookShipmentError
     */
    violations: Array<BookingFieldViolation>;
}

/**
 * Check if a given object implements the BookShipmentError interface.
 */
export function instanceOfBookShipmentError(value: object): value is BookShipmentError {
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    if (!('violations' in value) || value['violations'] === undefined) return false;
    return true;
}

export function BookShipmentErrorFromJSON(json: any): BookShipmentError {
    return BookShipmentErrorFromJSONTyped(json, false);
}

export function BookShipmentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookShipmentError {
    if (json == null) {
        return json;
    }
    return {
        
        'errorMessage': json['errorMessage'],
        'violations': ((json['violations'] as Array<any>).map(BookingFieldViolationFromJSON)),
    };
}

  export function BookShipmentErrorToJSON(json: any): BookShipmentError {
      return BookShipmentErrorToJSONTyped(json, false);
  }

  export function BookShipmentErrorToJSONTyped(value?: BookShipmentError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'errorMessage': value['errorMessage'],
        'violations': ((value['violations'] as Array<any>).map(BookingFieldViolationToJSON)),
    };
}

